// extracted by mini-css-extract-plugin
export var partner = "PageDataBodyPartnerGrid-module--partner--xEL3a";
export var partnerGrid = "PageDataBodyPartnerGrid-module--partnerGrid--rnNck";
export var partners = "PageDataBodyPartnerGrid-module--partners--Z7JDg";
export var selected = "PageDataBodyPartnerGrid-module--selected--gYmpQ";
export var show = "PageDataBodyPartnerGrid-module--show--dGwff";
export var tab = "PageDataBodyPartnerGrid-module--tab--yReX1";
export var tabs = "PageDataBodyPartnerGrid-module--tabs--5ogjK";